import React from 'react';
import styles from './Outsourcing.module.scss';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CountUp from 'react-countup';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import IconButton from '@mui/material/IconButton';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import Divider from '@mui/material/Divider';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';

const Outsourcing = () => (
  <div className={styles.Outsourcing} data-testid="Outsourcing">
    <Card sx={{ padding: 0, boxShadow: 0 }} >
        <CardHeader sx={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 1, }} action={
            <IconButton aria-label="settings" color='primary' sx={{ marginRight: 1, }} >
                {/* <SettingsSuggestIcon /> */}
            </IconButton>
        }
            title="Outsourcing" />
        <Divider />
        <CardContent sx={{ paddingLeft: 0, paddingRight: 0, }}>
            <Stack spacing={1} direction="row" useFlexGap flexWrap="wrap">
                <Box className="box-tile" sx={{ backgroundColor: 'tertiary.main', padding: 2, color: 'tertiary.contrastText' }}>
                    <Typography variant="body2" gutterBottom >
                        Available Subcontractors
                    </Typography>
                    <Typography component="h1" variant="h5" >
                        <CountUp duration={1} enend={500} enableScrollSpy />
                    </Typography>
                </Box>
                <Box className="box-tile" sx={{ backgroundColor: 'tertiary.main', padding: 2, color: 'tertiary.contrastText' }}>
                    <Typography variant="body2" gutterBottom >
                        Last miles agent
                    </Typography>
                    <Typography component="h1" variant="h5" >
                        <CountUp duration={1} enend={500} enableScrollSpy />
                    </Typography>
                </Box>
                <Box className="box-tile" sx={{ backgroundColor: 'tertiary.main', padding: 2, color: 'tertiary.contrastText' }}>
                    <Typography variant="body2" gutterBottom >
                        First mile agent
                    </Typography>
                    <Typography component="h1" variant="h5" >
                        <CountUp duration={1} end={54210} enableScrollSpy />
                    </Typography>
                </Box>
            </Stack>
        </CardContent>
    </Card>
  </div>
);

export default Outsourcing;